import { customGridAddSkuData } from '../helpers';

export default {
    name: 'fulfillmentAllShipmentGridPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'fulfillmentAll';
        const route = app.routes.getItem(routeName);
        
        if (route) {
            const customUnwantedStatus = (statuses) => statuses.filter((status) => status !== 'unknown');
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                customGridData :customGridAddSkuData,
                customUnwantedStatus,
                // to remove in 32.X.X core release
                permissions: {
                    canView: true,
                    canReship: true,
                    canRefund: false,
                    withExport: true,
                    withOrderDetailsLink: true,
                    withFulfillmentDetailsLink: true,
                },
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
